import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Card, Field, Input } from "@aigntx/ui";
import { endpoints } from "../api";
import { useAuth } from "../auth";
import { useTenant } from "../tenant";
import { ThemeControls } from "../ThemeControls";
import { BrandMark } from "../BrandMark";

export function ResetPage() {
  const { t } = useTranslation();
  const tenant = useTenant();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    if (pw !== confirm) {
      setError(t("account.mismatch"));
      return;
    }
    setBusy(true);
    try {
      setUser(await endpoints.resetPassword(token, pw));
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <div className="auth__top">
        <ThemeControls />
      </div>
      <Card className="auth__card">
        <div className="auth__brand">
          <BrandMark icon={tenant.theme.icon} size={34} />
          <span className="brand__name">{tenant.name}</span>
        </div>
        <h1 className="auth__title">{t("reset.title")}</h1>
        <p className="auth__sub">{t("reset.subtitle")}</p>

        {!token ? (
          <div className="form-err">{t("reset.noToken")}</div>
        ) : (
          <form className="auth__form" onSubmit={submit}>
            <Field label={t("account.new")} hint={t("users.pwHint")}>
              <Input
                type="password"
                autoComplete="new-password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                required
              />
            </Field>
            <Field label={t("account.confirm")} error={error || undefined}>
              <Input
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                invalid={Boolean(error)}
                required
              />
            </Field>
            <Button type="submit" block loading={busy}>
              {t("reset.submit")}
            </Button>
          </form>
        )}
        <Link className="auth__link" to="/login">
          {t("forgot.backToLogin")}
        </Link>
      </Card>
    </div>
  );
}
